// Using example from Tailwind UI: https://tailwindui.com/components/application-ui/elements/dropdowns
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import Image from 'next/image';
import Link from 'next/link';
import { FaChevronDown, FaImages, FaPhotoVideo, FaTiktok, FaVideo } from 'react-icons/fa';
import { BsDisplay, BsPhone, BsDisplayFill, BsPhoneFill } from 'react-icons/bs';
import { BiDevices } from 'react-icons/bi';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function TypeSort({ onClick, current }) {
  return (
    <Menu as="div" className="relative inline-block text-left z-40">
      <div>
        <Menu.Button className={`inline-flex items-center flex-row font-BreezeButton gap-x-2 text-xs leading-tight px-4 py-2 ${current !== "unsorted" ? "bg-violet-200" : "bg-violet-400 hover:bg-violet-300"} active:shadow-lg transition-colors duration-500 ease-in-out uppercase text-sp text-black rounded-full`}>
          
          {
            current === "videos" && <><BsDisplayFill className="w-6 h-4" /> Videos</> ||
            current === "shorts" && <><BsPhoneFill className="w-6 h-4" /> Shorts</>
            || <><FaPhotoVideo className="w-6 h-4" /> Type</>
          }
          <FaChevronDown className="w-3" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute left-0 py-2 md:pb-1 w-56 rounded-md shadow-lg bg-slate-800 ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            <Menu.Item key="unsorted">
              {({ active }) => (
                <button
                    className={`${classNames(
                        active ? 'bg-gray-600 text-slate-100' : 'text-slate-100 hover:bg-gray-600',
                        'block px-4 py-2 text-sm'
                    )} flex flex-row gap-x-2 items-center w-full`}
                    onClick={(() => {onClick('unsorted')})}
                >
                    <BiDevices className="w-6 h-6" />
                    Everything
                </button>
              )}
            </Menu.Item>
            <Menu.Item key="videos">
              {({ active }) => (
                <button
                    className={`${classNames(
                        active ? 'bg-gray-600 text-slate-100' : 'text-slate-100 hover:bg-gray-600',
                        'block px-4 py-2 text-sm'
                    )} flex flex-row gap-x-2 items-center w-full`}
                    onClick={(() => {onClick('videos')})}
                >
                    <BsDisplay className="w-6 h-6" />
                    Videos
                </button>
              )}
            </Menu.Item>
            <Menu.Item key="shorts">
              {({ active }) => (
                <button
                    className={`${classNames(
                        active ? 'bg-gray-600 text-slate-100' : 'text-slate-100 hover:bg-gray-600',
                        'block px-4 py-2 text-sm'
                    )} flex flex-row gap-x-2 items-center w-full`}
                    onClick={(() => {onClick('shorts')})}
                >
                    <BsPhone className="w-6 h-6" />
                    Shorts
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}